import { WidgetAuthErrorEnum } from 'src/app/widget-auth/models/widget-auth-error.enum';
import { FatalErrorReportModel } from 'src/app/shared/error/error.model';

// default config
export const defaultAuthErrorConfig: FatalErrorReportModel = {
  title: 'Your BioDigital Human embed requires proper authentication.',
  description: ''
};

// custom user defined messages based on auth error type
export const authErrorConfig: { [key: string]: FatalErrorReportModel } = {
  [WidgetAuthErrorEnum.InvalidUAID]: {
    title: 'Authentication Issues',
    description: 'Your Human Widget has invalid user credentials.',
    url: 'https://support.biodigital.com'
  }
};
